import client from "./eaffidavitClient"
import Links from "../constants/Links"

// Upstream sometimes returns raw arrays, sometimes paginated/wrapped envelopes
// like {data:[...]}, {items:[...]}, {content:[...]}, {results:[...]}. Normalise
// so callers always see a plain array.
function unwrapList(res) {
    const d = res?.data
    if (Array.isArray(d)) return d
    if (d && typeof d === "object") {
        for (const key of ["data", "items", "content", "results", "records"]) {
            if (Array.isArray(d[key])) return d[key]
        }
    }
    return []
}

function asList(promise) {
    return promise.then(res => ({...res, data: unwrapList(res)}))
}

// For single-object endpoints: if the response is an envelope like
// {data: {...}} / {result: {...}}, return the inner object.
function unwrapObject(res) {
    const d = res?.data
    if (!d || typeof d !== "object" || Array.isArray(d)) return d
    for (const key of ["data", "result", "content"]) {
        const inner = d[key]
        if (inner && typeof inner === "object" && !Array.isArray(inner)) return inner
    }
    return d
}

function asObject(promise) {
    return promise.then(res => ({...res, data: unwrapObject(res)}))
}

const EAffidavit = {
    countries: async () => asList(client.get(Links.eaffidavit.countries)),
    states: async (countryId) => asList(client.get(Links.eaffidavit.states, {params: {country_id: countryId}})),
    lgas: async (stateId) => asList(client.get(Links.eaffidavit.lgas, {params: {state_id: stateId}})),
    courts: async () => asList(client.get(Links.eaffidavit.courts)),

    listTemplates: async () => asList(client.get(Links.eaffidavit.templates)),
    getTemplate: async (id) => asObject(client.get(Links.eaffidavit.template + id)),

    me: async () => client.get(Links.eaffidavit.me),

    uploadIdentityCard: async (file) => {
        const data = new FormData()
        data.append("kind", "identity_card")
        data.append("file", file)
        return asObject(client.post(Links.eaffidavit.uploads, data))
    },

    createApplication: async (payload) => asObject(client.post(Links.eaffidavit.applications, payload)),

    listApplications: async () => asList(client.get(Links.eaffidavit.applications)),

    getApplication: async (clientRef, refresh = false) =>
        asObject(client.get(Links.eaffidavit.application + clientRef, {params: refresh ? {refresh: true} : {}})),

    regenerateCheckout: async (clientRef, paymentRedirectUrl) =>
        asObject(client.post(
            Links.eaffidavit.regenerateCheckout + clientRef + "/regenerate-checkout",
            {paymentRedirectUrl},
        )),

    verifyPayment: async (clientRef) =>
        asObject(client.post(Links.eaffidavit.verifyPayment + clientRef + "/verify-payment")),

    downloadReceipt: async (clientRef) =>
        client.get(Links.eaffidavit.receipt + clientRef + "/receipt", {responseType: "blob"}),

    downloadAffidavit: async (clientRef) =>
        client.get(Links.eaffidavit.affidavit + clientRef + "/affidavit", {responseType: "blob"}),
}

export default EAffidavit
